import types from './types';

export default {
  [types.SET_PROVIDERS](state, providers) {
    state.providers = providers;
  },
  [types.SET_PROVIDERID](state, providerId) {
    state.providerId = providerId;
  },
  [types.SET_YEARS](state, years) {
    state.years = years;
  },
  [types.SET_STATUSES](state, statuses) {
    state.statuses = statuses;
  },
  [types.SET_PROVIDERSLIST](state, providersList) {
    state.providersList = providersList;
  },
  [types.SET_PROPOSAL_PROVIDERS](state, providers) {
    state.proposal.providers = providers;
  },
  [types.SET_PROPOSAL_ACADEMICYEARS](state, academicYears) {
    state.proposal.academicYears = academicYears;
  },
  [types.SET_PROPOSAL_DEFAULTACADEMICYEAR](state, defaultAcademicYear) {
    state.proposal.defaultAcademicYear = defaultAcademicYear;
  },
  [types.SET_PROPOSAL_AREAS](state, areas) {
    state.proposal.areas = areas;
  },
  [types.SET_PROPOSAL_EVALUATORS](state, evaluators) {
    state.proposal.evaluators = evaluators;
  },
  [types.SET_PROPOSAL_STATUSES](state, statuses) {
    state.proposal.statuses = statuses;
  },
  [types.SET_MUNICIPALITIES](state, municipalities) {
    state.municipalities = municipalities;
  },
  [types.SET_COMPANYTYPES](state, companyTypes) {
    state.companyTypes = companyTypes;
  },
  [types.SET_CAN_BE_ASSIGNED_TO_EVALUATORS](state, status) {
    state.proposal.canBeAssignedToEvaluators = status;
  },
  [types.SET_PREVIEW_LIST_PROPOSAL_ASSIGNED_TO_EVALUATORS](state, list) {
    state.proposal.previewListProposalAssignedToEvaluators = list;
  },
  [types.SET_SERVICE_LOCATION_FILTERS](state, payload) {
    state.serviceLocationFilters = payload;
  },
  [types.SET_COMPANY_SSN](state, payload) {
    state.companySSN = payload;
  },
};
